import React, { useState } from 'react';

const QuoteForm = ({ onGenerate, loading, darkMode }) => {
  const [category, setCategory] = useState('');
  const [language, setLanguage] = useState('sk');

  const handleSubmit = (e) => {
    e.preventDefault();
    onGenerate(category, language);
  };

  const categories = [
    { value: '', label: '🎲 Náhodný', emoji: '🎲' },
    { value: 'work', label: '💼 Práca', emoji: '💼' },
    { value: 'love', label: '❤️ Láska', emoji: '❤️' },
    { value: 'life', label: '🌱 Život', emoji: '🌱' },
    { value: 'success', label: '🏆 Úspech', emoji: '🏆' },
    { value: 'motivation', label: '💪 Motivácia', emoji: '💪' },
    { value: 'wisdom', label: '🧠 Múdrosť', emoji: '🧠' },
    { value: 'friendship', label: '👫 Priateľstvo', emoji: '👫' }
  ];

  const languages = [
    { value: 'sk', label: '🇸🇰 Slovenčina', flag: '🇸🇰' },
    { value: 'en', label: '🇺🇸 Angličtina', flag: '🇺🇸' },
    { value: 'cz', label: '🇨🇿 Čeština', flag: '🇨🇿' },
    { value: 'de', label: '🇩🇪 Nemčina', flag: '🇩🇪' }
  ];

  return (
    <div className="form-card">
      <form onSubmit={handleSubmit} className="quote-form">
        <div className="form-header">
          <h2>🎯 Vytvorte si citát na mieru</h2>
          <p>Vyberte si kategóriu a jazyk pre váš motivačný citát</p>
        </div>
        
        <div className="quick-actions">
          <button
            type="button"
            onClick={() => {
              setCategory('');
              setLanguage('sk');
              onGenerate('', 'sk');
            }}
            className="quick-action-button"
            disabled={loading}
          >
            🎲 Náhodný SK
          </button>
          
          <button
            type="button"
            onClick={() => {
              setCategory('motivation');
              setLanguage('sk');
              onGenerate('motivation', 'sk');
            }}
            className="quick-action-button"
            disabled={loading}
          >
            💪 Motivácia
          </button>
          
          <button
            type="button"
            onClick={() => {
              setCategory('success');
              setLanguage('sk');
              onGenerate('success', 'sk');
            }}
            className="quick-action-button"
            disabled={loading}
          >
            🏆 Úspech
          </button>
          
          <button
            type="button"
            onClick={() => {
              setCategory('');
              setLanguage('en');
              onGenerate('', 'en');
            }}
            className="quick-action-button"
            disabled={loading}
          >
            🎲 Random EN
          </button>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>
              <span className="label-icon">🎯</span>
              Kategória:
            </label>
            <select 
              value={category} 
              onChange={(e) => setCategory(e.target.value)} 
              className="form-control"
            >
              {categories.map(cat => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label>
              <span className="label-icon">🌍</span>
              Jazyk:
            </label>
            <select 
              value={language} 
              onChange={(e) => setLanguage(e.target.value)} 
              className="form-control"
            >
              {languages.map(lang => (
                <option key={lang.value} value={lang.value}>
                  {lang.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="form-actions">
          <button 
            type="submit" 
            className="generate-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="loading-spinner"></span>
                ⏳ Generujem...
              </>
            ) : (
              <>
                <span className="button-icon">🎲</span>
                Generovať citát
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default QuoteForm;
